var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6564 6.81434C10.3818 6.53975 9.93664 6.53975 9.66205 6.81434L4.97455 11.5019C4.69995 11.7765 4.69995 12.2216 4.97455 12.4962L9.66205 17.1837C9.93664 17.4583 10.3818 17.4583 10.6564 17.1837C10.931 16.9091 10.931 16.464 10.6564 16.1894L6.46611 11.999L10.6564 7.80871C10.931 7.53412 10.931 7.08892 10.6564 6.81434Z",
    fill: "#1F396C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16921 11.2959H14.8467C15.7404 11.2959 17.0654 11.5582 18.1872 12.366C19.3448 13.1994 20.2373 14.5824 20.2373 16.6865C20.2373 17.0748 19.9225 17.3896 19.5342 17.3896C19.1459 17.3896 18.8311 17.0748 18.8311 16.6865C18.8311 15.0406 18.161 14.0799 17.3655 13.5072C16.5342 12.9086 15.5154 12.7021 14.8467 12.7021H7.16921L6.46609 11.999L7.16921 11.2959Z",
    fill: "#1F396C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.82129 11.7295C4.78688 11.8124 4.76795 11.9033 4.76795 11.9986C4.76795 11.9071 4.78576 11.8155 4.82129 11.7295Z",
    fill: "#1F396C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.9ae362973d7f19c369e8e760aa0392c0.svg";
export { ForwardRef as ReactComponent };